export function checkIfFastShipActive( route ){

    return route.query?.Shipdate && route.query?.Shipdate != 'any'
}

export function getCouponLabel(discount){
    return `${discount}% OFF`
}
